var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69727 43.593H26.7965C27.7345 43.593 28.4938 42.8337 28.4938 41.8958H5C5 42.8337 5.75931 43.593 6.69727 43.593Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7965 51.8114H6.69727C5.75931 51.8114 5 52.5707 5 53.5087H28.4938C28.4938 52.5707 27.7345 51.8114 26.7965 51.8114Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5559 44.397H5.93799V51.0521H27.5559V44.397Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5137 25.459L34.1663 24.6104C34.1663 24.6104 51.0497 49.2208 46.8958 51.3648C42.6973 53.464 32.5137 25.459 32.5137 25.459Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8009 21.8932L31.0933 22.7723L32.9127 26.3066L34.6203 25.4276L32.8009 21.8932Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1996 20.6764L30.4922 21.5556L30.7989 22.1512L32.5063 21.272L32.1996 20.6764Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1911 20.9925L31.8884 20.0992L33.139 16.4367C31.0844 17.5087 26.4839 19.8759 26.4839 19.8759L30.1911 20.9925Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.238 13.2655C35.8186 14.3821 35.372 15.7667 34.2553 16.3474L25.8137 20.6799C24.697 21.2605 23.3124 20.8139 22.7318 19.6973L20.4985 15.3648C19.9179 14.2481 20.3645 12.8635 21.4812 12.2829L29.9228 7.95036C31.0395 7.36972 32.4241 7.81637 33.0047 8.933L35.238 13.2655Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3123 22.3325C23.4463 22.6452 23.357 23.0025 23.0444 23.1365C22.7317 23.2705 22.3744 23.1812 22.2404 22.8685L17.6399 13.9355C17.5059 13.6228 17.5952 13.2655 17.9079 13.1315C18.2205 12.9975 18.5779 13.0869 18.7118 13.3995L23.3123 22.3325Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0965 14.7394C38.2305 15.0521 38.1412 15.4094 37.8285 15.5434C37.5159 15.6774 37.1586 15.5881 37.0246 15.2754L32.4241 6.34242C32.2901 6.02976 32.3794 5.67244 32.6921 5.53845C33.0047 5.40445 33.362 5.49378 33.496 5.80644L38.0965 14.7394Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8062 13.5335C12.1908 16.2134 14.692 21.1266 14.692 21.1266C14.692 21.1266 17.1932 25.9951 18.5779 28.7196C21.2131 27.3797 21.3471 23.0025 21.3471 23.0025L19.2032 18.804L17.0593 14.6055C17.0593 14.6055 13.4414 12.1936 10.8062 13.5335Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8859 15.1861C43.5013 12.5062 41 7.59305 41 7.59305C41 7.59305 38.4541 2.6799 37.0695 0C34.4343 1.33995 34.3003 5.71712 34.3003 5.71712L36.4442 9.91563L38.5881 14.1141C38.6328 14.1141 42.2953 16.5261 44.8859 15.1861Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1636 51.9007C46.5383 52.2134 45.5557 52.0347 45.5557 52.0347C47.2529 54.4467 48.2356 54 48.2356 54C48.2356 54 49.1735 53.464 48.1909 50.6948C48.1909 50.6501 47.8336 51.5434 47.1636 51.9007Z",
    fill: "#E9E6D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.6377,
    height: 54,
    fill: "white",
    transform: "translate(5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon02);
export default __webpack_public_path__ + "static/media/cardicon02.e5050881c84854aa4b5dad1a5967b2a7.svg";
export { ForwardRef as ReactComponent };